import React from "react";
var __jsx = React.createElement;
import stl from "./RadioButtonMD.module.css";
var SingleRadioMD = function SingleRadioMD(_ref) {
  var name = _ref.name,
    value = _ref.value,
    title = _ref.title,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "radio" : _ref$type,
    onChange = _ref.onChange,
    selected = _ref.selected;
  return /*#__PURE__*/React.createElement("label", {
    className: stl.SingleRadioMD_Container
  }, /*#__PURE__*/React.createElement("input", {
    type: type,
    name: name,
    value: value,
    onChange: onChange,
    checked: selected
  }), /*#__PURE__*/React.createElement("span", null, title));
};
export default SingleRadioMD;